import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64626199"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-msg-copy" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-msg-copy" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-msg-forward" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-msg-quote" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-msg-reply" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-msg-revoke" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-msg-del" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageEmojiReact = _resolveComponent("MessageEmojiReact")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["dialog-item", _ctx.env?.isH5 ? 'dialog-item-h5' : 'dialog-item-web'])
  }, [
    (_ctx.env?.isH5 && _ctx.needEmojiReact)
      ? (_openBlock(), _createBlock(_component_MessageEmojiReact, {
          key: 0,
          message: _ctx.message,
          type: "dropdown",
          onHandleCollapse: _ctx.handleCollapse
        }, null, 8, ["message", "onHandleCollapse"]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("ul", {
      class: _normalizeClass(["dialog-item-list", _ctx.env?.isH5 ? 'dialog-item-list-h5' : 'dialog-item-list-web'])
    }, [
      (
          (_ctx.message.type === _ctx.types.MSG_FILE || _ctx.message.type === _ctx.types.MSG_VIDEO || _ctx.message.type === _ctx.types.MSG_IMAGE) &&
          !_ctx.env.isH5
        )
        ? (_openBlock(), _createElementBlock("li", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openMessage(_ctx.message)))
          }, [
            _hoisted_1,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('TUIChat.打开')), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.message.type === _ctx.types.MSG_TEXT)
        ? (_openBlock(), _createElementBlock("li", {
            key: 1,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleMessage(_ctx.message, _ctx.constant.handleMessage.copy)))
          }, [
            _hoisted_2,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('TUIChat.复制')), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.message.status === 'success')
        ? (_openBlock(), _createElementBlock("li", {
            key: 2,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleMessage(_ctx.message, _ctx.constant.handleMessage.forward)))
          }, [
            _hoisted_3,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('TUIChat.转发')), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.message.status === 'success')
        ? (_openBlock(), _createElementBlock("li", {
            key: 3,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleMessage(_ctx.message, _ctx.constant.handleMessage.reference)))
          }, [
            _hoisted_4,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('TUIChat.引用')), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.message.status === 'success')
        ? (_openBlock(), _createElementBlock("li", {
            key: 4,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleMessage(_ctx.message, _ctx.constant.handleMessage.reply)))
          }, [
            _hoisted_5,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('TUIChat.回复')), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.message.flow === 'out' && _ctx.message.status === 'success' && _ctx.message.type !== _ctx.types.MSG_CUSTOM)
        ? (_openBlock(), _createElementBlock("li", {
            key: 5,
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleMessage(_ctx.message, _ctx.constant.handleMessage.revoke)))
          }, [
            _hoisted_6,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('TUIChat.撤回')), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.message.status === 'success')
        ? (_openBlock(), _createElementBlock("li", {
            key: 6,
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleMessage(_ctx.message, _ctx.constant.handleMessage.delete)))
          }, [
            _hoisted_7,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('TUIChat.删除')), 1)
          ]))
        : _createCommentVNode("", true)
    ], 2), [
      [_vShow, _ctx.showToolList]
    ])
  ], 2))
}